import Style from "./style"
import close from "./asset/close.svg"

const ImageModal = ({ src, closeEvent }) => {

    return (
        <Style.ModalBackground onClick={closeEvent}>
            <Style.Modal>
                <img src={src} />
            </Style.Modal>
        </Style.ModalBackground>
    )
}

export default ImageModal